import React from "react"
import { Col, Row } from "reactstrap"

const Error = props => {

  return (
    <React.Fragment>
      <div className="modal-header">
        <h5 className="modal-title mt-0">Error</h5>
      </div>

      <div className="modal-body">
        <Row>
          <Col className="d-flex justify-content-center">
            <i className="fas fa-ban font-size-28 text-danger"></i>{" "}
          </Col>
        </Row>
        <Row>
          <Col className="d-flex justify-content-center text-danger mt-3">
            {props.message}
          </Col>
        </Row>
      </div>

      <div className="modal-footer">
        <button
          type="button"
          className="btn btn-danger"
          onClick={() => props.closeModal()}
        >
          OK
        </button>
      </div>
    </React.Fragment>
  )
}

export default Error
